<h2 class="first_title">Prossimi adempimenti</h2>
<div export-help [pageNumber]="'156'"></div>
<div class="content-page-wrapper">
	<div class="standardpanel">
	
		<div class="container_tab_nav">
			<p>Visualizza</p>	
				
			<ul class="nav nav-tabs four scadenzario">
				<li class="active" id="all"><a data-toggle="tab"
					href="#tabcontent1" (click)="filterScadenza('');">Tutti</a></li>
				<li *ngFor="let tipoScadenza of tipiScadenze"
					id="ts-{{tipoScadenza.id}}"><a data-toggle="tab"
					href="#tabcontent1" (click)="filterScadenza(tipoScadenza.label);">{{tipoScadenza.label}}</a></li>
			</ul>
			<div class="tab-content">
				<div id="tabcontent1" class="tab-pane fade in active">
				<ul prossimi-adempimenti-list class="att_completare" [adempimenti]="adempimenti" [viewOption]="true" [slice]="numToView" (onReturn)="adempimentoEvaso()" (rinvia)="apriModaleRinvio($event)"></ul>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="searchAdempimentiResponse && isViewAll"  class="standardpanel">
	<div class="row">				
		<p *ngIf="searchAdempimentiResponse.setNumeroAdempimentiTotali > adempimenti.length" class="allinea_centro col-sm-12">
				<a href="javascript:void(0);" (click)="loadProssimiAdempimenti()">
				<strong>Carica altri risultati</strong></a></p>					
		<p *ngIf="searchAdempimentiResponse.setNumeroAdempimentiTotali <= adempimenti.length" class="allinea_centro col-sm-12"><strong>Non ci sono altri risultati</strong></p>				
		<p class="allinea_centro col-sm-12"><strong>Risultati {{adempimenti.length}} di {{searchAdempimentiResponse.setNumeroAdempimentiTotali}}</strong></p>
	</div>
	</div>
</div>
       
<div class="modal modal-static" id="processing-modal" role="dialog"
	aria-hidden="false" *ngIf="waitResponseSearch">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-body">
				<div class="text-center">
					<div class="sk-circle">
						<div class="sk-circle1 sk-child"></div>
						<div class="sk-circle2 sk-child"></div>
						<div class="sk-circle3 sk-child"></div>
						<div class="sk-circle4 sk-child"></div>
						<div class="sk-circle5 sk-child"></div>
						<div class="sk-circle6 sk-child"></div>
						<div class="sk-circle7 sk-child"></div>
						<div class="sk-circle8 sk-child"></div>
						<div class="sk-circle9 sk-child"></div>
						<div class="sk-circle10 sk-child"></div>
						<div class="sk-circle11 sk-child"></div>
						<div class="sk-circle12 sk-child"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div modale_rinvio_scadenza [attr.id]="'modalrinvioscad'"
	(onReturn)="adempimentoRinviato()" #modaleRinvioScadenza></div>